module.exports = __webpack_public_path__ + "static/presidents-message-5a0d1dc18b443863d8056030cfec1a5e.jpg";